'use strict';

Groupon.MerchantVideos = class MerchantVideos {
  constructor(el, provider, videoId, onlyShowingVideos) {
    this.el = el;
    this.provider = provider;
    this.videoId = videoId;
    this.onlyShowingVideos = onlyShowingVideos;
    this.$videos = $(this.el);
    this.OOVideo = null;
    this.getVideoScripts();
    this.MIN_WIDTH = 979;
    $(window).on('resize', () => this.onResize());
  }

  getVideoScripts() {
    return $(() => {
      let script;

      switch (this.provider) {
        case 'KALTURA':
          script =
            '//www.kaltura.com/p/1302621/sp/130262100/embedIframeJs/uiconf_id/11486911/partner_id/1302621';
          break;

        case 'OOYALA':
          script = '//player.ooyala.com/v3/4e60e82cdbc14def8b05623206f02388';
          break;

        default:
          return this.removeVideoContainer();
      }

      return $.getScript(script)
        .done(() => this.setupVideo())
        .fail(() => this.removeVideoContainer());
    });
  }

  setupVideo() {
    if (typeof kWidget !== 'undefined' && kWidget !== null) {
      return kWidget.embed({
        targetId: 'kaltura-player-1360194818',
        cache_st: 1360194818,
        wid: '_1302621',
        uiconf_id: '11486911',
        flashvars: {
          autoPlay: false,
          streamerType: 'hdnetwork',
          akamaiHD: {
            loadingPolicy: 'preInitialize',
            asyncInit: 'true',
          },
        },
        entry_id: this.videoId,
      });
    } else if (typeof OO !== 'undefined' && OO !== null) {
      this.OOVideo = OO.Player.create('ooyala-player', this.videoId, {
        autoplay: false,
      });
      return this.OOVideo;
    }
    return null;
  }

  removeVideoContainer() {
    if (this.onlyShowingVideos) {
      return this.$videos.parent().remove();
    } else {
      return this.$videos.remove();
    }
  }

  destroyOoyalaVideo() {
    if (
      typeof OO !== 'undefined' &&
      OO !== null &&
      $(window).width() <= this.MIN_WIDTH
    ) {
      if (this.OOVideo != null) {
        this.OOVideo.destroy();
      }

      this.OOVideo = null;
      return this.OOVideo;
    }
    return null;
  }

  createOoyalaVideo() {
    if (
      typeof OO !== 'undefined' &&
      OO !== null &&
      $(window).width() > this.MIN_WIDTH &&
      !this.OOVideo
    ) {
      this.OOVideo = OO.Player.create('ooyala-player', this.videoId, {
        autoplay: false,
      });
      return this.OOVideo;
    }
    return null;
  }

  onResize() {
    let timer;

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      this.destroyOoyalaVideo();
      return this.createOoyalaVideo();
    }, 250);
    return timer;
  }
};
$(() => {
  const el = '.mpp-container .merchant-videos';

  if (!($(el).length > 0)) {
    return null;
  }

  const videosConfig = $(el).data();
  return new Groupon.MerchantVideos(
    el,
    videosConfig.provider,
    videosConfig.videoId,
    videosConfig.onlyVideos
  );
});
